import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const LanguageToggle = () => {
  const { lang, toggleLang } = useLanguage();
  
  return (
    <button
      onClick={toggleLang}
      className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-full bg-slate-100 hover:bg-slate-100 border border-slate-200 transition-all duration-200"
      data-testid="language-toggle"
      aria-label="Toggle language"
    >
      <span className={`text-sm font-medium transition-colors ${lang === 'fr' ? 'text-[#172033]' : 'text-slate-500'}`}>
        FR
      </span>
      <span className="text-slate-400">/</span>
      <span className={`text-sm font-medium transition-colors ${lang === 'nl' ? 'text-[#172033]' : 'text-slate-500'}`}>
        NL
      </span>
    </button>
  );
};
